/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_No_EndpointInputs */



/**
* | output |
* | --- |
* | "No endpoint configured" |
*
* @param {Live_Caption_No_EndpointInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_no_endpoint = /** @type {((inputs?: Live_Caption_No_EndpointInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_No_EndpointInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun point de terminaison configuré")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Endpunkt konfiguriert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun endpoint configurato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Конечная точка не настроена")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se ha configurado ningún punto final.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未配置端点")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エンドポイントが設定されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई एंडपॉइंट कॉन्फ़िगर नहीं किया गया है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum ponto de extremidade configurado")
	return /** @type {LocalizedString} */ ("No endpoint configured")
});